var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.309-340.001q-28.539 0-50.423-21.885-21.884-21.884-21.884-50.423v-64.614q0-6.297 1.615-13.495 1.615-7.197 3.615-13.428l114.633-270.506q8.598-19.185 28.828-32.416 20.231-13.231 42.218-13.231h420.627v479.998L438.846-109.31q-11.923 11.923-27.615 14.23-15.692 2.308-30.076-5.384t-21.076-21.845q-6.693-14.154-2.846-29.307l43.076-188.385h-268Zm479.23-25.538V-760H250.77q-4.231 0-8.654 2.308-4.424 2.308-6.732 7.693L120-480v67.691q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h343.845L426-180.769l185.539-184.77Zm176.152-454.46q29.827 0 51.067 21.241 21.241 21.24 21.241 51.067v335.382q0 29.827-21.241 51.067-21.24 21.241-51.067 21.241H671.538V-400h116.153q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-335.382q0-5.385-3.462-8.847-3.462-3.462-8.847-3.462H671.538v-59.999h116.153ZM611.539-760v394.461V-760Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumbDown.db71deb79d487d4b2664c5b8350dde30.svg";
export { ForwardRef as ReactComponent };